
import { reactive, inject} from 'vue';
import {MenuMore} from '@/hooks/index'
import HDeader from '@/components/header/header.vue';

export default {
  components: { HDeader },
  props:{},
  setup(props: object){
    const $http: any = inject('$http')
    const $store: any = inject('$store')

    const moreMenu:Array<MenuMore> = [
      {
          icon:'like-o',
          title:'Wish List',
          type:0,
          url:'/a',
      },
      {
          icon:'location-o',
          title:'Wish List',
          type:0,
          url:'/a',
      },
    ] 
    console.log(333)
      const  get_product_datas_fn = async () => {
        let ret = await $http.get_product_detail(286186)
        console.log(ret)
      }
      get_product_datas_fn()
      
      return {
        moreMenu
      }
  }
}
